var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"offset-md-0 offset-1"},[_c('button',{ref:"btnTextToggle",staticClass:"btn breadcrumb-button mx-md-3 mx-0 mb-3",on:{"click":_vm.loadAdminData}},[_vm._v("\n    "+_vm._s(_vm.CONSTANTS.ADMIN_AP_VIEW_TITLE)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }